import { z } from 'zod'
import { Name } from '../../_kernel/Name'
import { Slug } from '../../_kernel/Slug'
import type { GETThemesResponseType } from '../infrastructure/HTTPPropertyRepository/schemas/themes/index'
import { PropertyFilter } from './PropertyFilter'

export const ThemeValidation = z.object({
  name: z.instanceof(Name, { message: '[Theme] name is required' }),
  slug: z.instanceof(Slug, { message: '[Theme] slug is required' }),
})

export class Theme extends PropertyFilter {
  static create({ name, slug }: z.infer<typeof ThemeValidation>) {
    ThemeValidation.parse({ name, slug })
    return new Theme(name, slug)
  }

  static fromAPI({ json }: { json: GETThemesResponseType['themes'][number] }) {
    return Theme.create({
      name: Name.create({ value: json.name }),
      slug: Slug.create({ value: json.slug }),
    })
  }
}
